/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Action_DeductInputs */

const en_admin_users_credits_action_deduct = /** @type {(inputs: Admin_Users_Credits_Action_DeductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deduct`)
};

/**
* | output |
* | --- |
* | "Deduct" |
*
* @param {Admin_Users_Credits_Action_DeductInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_action_deduct = /** @type {((inputs?: Admin_Users_Credits_Action_DeductInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Action_DeductInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_credits_action_deduct(inputs)
});
export { admin_users_credits_action_deduct as "admin.users.credits_action_deduct" }